// extracted by mini-css-extract-plugin
module.exports = {"menu":"SelectPerformance_menu__pFW3C","title":"SelectPerformance_title__uOu00"};